import { ICON_TYPES } from '../constants';
import { IconPropsType } from '../IconProps.type';
export const CloseIcon = (props: IconPropsType) => {
  const { fill = '#43494F' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
      <path
        d="M12.707,12l5.646-5.646a.5.5,0,1,0-.707-.707L12,11.293,6.354,5.646a.5.5,0,1,0-.707.707L11.293,12,5.646,17.646a.5.5,0,1,0,.707.707L12,12.707l5.646,5.646a.5.5,0,1,0,.707-.707Z"
        transform="translate(-5.5 -5.5)"
      />
    </svg>
  );
};

CloseIcon.iconType = ICON_TYPES.CLOSE;
